"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showSpinner = exports.isReferDisabled = exports.hasMaxReferrals = exports.hasReferrals = exports.canRefer = void 0;
const constants_1 = require("../common/constants");
const canRefer = (state) => {
    return [
        `${constants_1.ReferralStates.initialized}`,
        `${constants_1.ReferralStates.noReferrals}`,
        `${constants_1.ReferralStates.someReferrals}`,
        `${constants_1.ReferralStates.maxReferrals}`
    ].some(state.matches);
};
exports.canRefer = canRefer;
const hasReferrals = (state) => {
    return [
        `${constants_1.ReferralStates.initialized}`,
        `${constants_1.ReferralStates.someReferrals}`,
        `${constants_1.ReferralStates.maxReferrals}`
    ].some(state.matches);
};
exports.hasReferrals = hasReferrals;
const hasMaxReferrals = (state) => {
    return [
        `${constants_1.ReferralStates.initialized}`,
        `${constants_1.ReferralStates.maxReferrals}`
    ].some(state.matches);
};
exports.hasMaxReferrals = hasMaxReferrals;
const isReferDisabled = (state) => {
    return [
        `${constants_1.ReferralStates.noReferrals}`,
        `${constants_1.ReferralStates.sendingReferralData}`,
        `${constants_1.ReferralStates.sendingReferralDataError}`
    ].some(state.matches);
};
exports.isReferDisabled = isReferDisabled;
const showSpinner = (state) => {
    return [`${constants_1.ReferralStates.sendingReferralData}`].some(state.matches);
};
exports.showSpinner = showSpinner;
//# sourceMappingURL=util.js.map